import { render, staticRenderFns } from "./T1Tabs.vue?vue&type=template&id=13d357f0&scoped=true&"
import script from "./T1Tabs.vue?vue&type=script&lang=js&"
export * from "./T1Tabs.vue?vue&type=script&lang=js&"
import style0 from "./T1Tabs.vue?vue&type=style&index=0&id=13d357f0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13d357f0",
  null
  
)

export default component.exports